export default __webpack_public_path__ + "static/media/chaves-automotivas.534d7696.png";